import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ContaHeader } from "@/components/conta/ContaHeader";
import { RequireSession } from "@/components/RequireSession";
import { useSession } from "@/lib/session";
import { SiteFooter } from "@/components/SiteCredit";

/**
 * Moldura da area do cliente.
 *
 * Pathless (`_conta`) porque /minha-conta/entrar nao deve herdar o header com
 * o chip da conta — quem ainda nao entrou nao tem conta para mostrar.
 */
export const Route = createFileRoute("/minha-conta/_conta")({
  component: ContaLayout,
});

function ContaLayout() {
  return (
    <RequireSession roles={["CLIENTE"]} redirectTo="/minha-conta/entrar">
      <Conta />
    </RequireSession>
  );
}

function Conta() {
  const { profile, logout } = useSession();

  return (
    <div className="flex min-h-screen flex-col bg-mb-surface">
      <ContaHeader name={profile?.name ?? ""} onLogout={() => void logout()} />
      <div className="grow">
        <Outlet />
      </div>
      <SiteFooter />
    </div>
  );
}
